// extracted by mini-css-extract-plugin
export default {"body":"TableBody_body__-UISN","empty":"TableBody_empty__JisYx"};